import Vue from 'vue'
import api from '../../api/api'

const music = {
  state: {
    cateList: [],
    musicList: []
  },

  mutations: {
    SET_CATE_LIST(state, data) {
      state.cateList = data
    },
    SET_MUSIC_LIST(state, data) {
      state.musicList = data
    }
  },

  actions: {
    //获取曲库分类
    async getscorelibcatalogs({ commit, rootState}) {
      let params = {
        catalogid:rootState.route.query.catalogid || 0
      }
      let ret = await api.getscorelibcatalogs(params)
      if(params.catalogid == 0) {
        commit('SET_CATE_LIST', ret.data)
      } else {
        commit('SET_CATE_LIST', ret.data[0].childcatalog)
      }
      
      console.log('曲库分类列表', ret)
    },

    //获取曲谱列表
    async getsonglibscores({ commit, rootState}) {
      let params = {
        catalogid:rootState.route.query.catalogid
      }
      let ret = await api.getsonglibscores(params)
      commit('SET_MUSIC_LIST', ret.data)
      
      console.log('曲谱列表', ret)
    }
  }

};

export default music


// WEBPACK FOOTER //
// ./src/store/modules/music.js